import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25deb9ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "sub-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "asknicely-icon-loader_static" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.containerClass)
  }, [
    (_ctx.type == 'dots')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          _createElementVNode("span", {
            class: _normalizeClass({ 'loader-dots': _ctx.loading })
          }, null, 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
  ], 2))
}